import PropTypes from "prop-types"

export const Person = PropTypes.exact({
  name: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  job: PropTypes.string.isRequired,
  description: PropTypes.string,
})
